import PropTypes from 'prop-types';

const LocationPinIcon = ({ className = '' }) => (
  <svg
    viewBox="0 0 24 24"
    aria-hidden="true"
    className={className}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 21s-6-5.2-6-11a6 6 0 1 1 12 0c0 5.8-6 11-6 11z" />
    <circle cx="12" cy="10" r="2.5" />
  </svg>
);

LocationPinIcon.propTypes = {
  className: PropTypes.string
};

export default LocationPinIcon;
